import GoogleAuthenticator from 'assets/images/googleauthenticator.svg'
import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import InputContainer from 'components/InputContainer'
import Row from 'components/Row'
import Text from 'components/Text'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import styled from 'styled-components'
import { color, theme } from 'utils'

import Container from '../Modal/Container'

const RadioContainer = styled(InputContainer)`
  padding: 1.5rem 1.5rem;
  border: 1px solid ${color('grey000')};
  border-radius: ${theme('inputBorderRadius')};
  cursor: default;
`

const Badge = styled.img`
  height: 4rem;
  width: 4rem;
  margin-right: 1.5rem;
  vertical-align: inherit;
`

const CenterRow = styled(Row)`
  align-items: center;
`

const Description = styled(Text)`
  margin-top: 0.5rem;
`

const ComingSoon = styled(Text)`
  margin-bottom: 2rem;
  align-self: center;
`

const Method = ({ intl }: WrappedComponentProps) => (
  <Container
    sub={intl.formatMessage(messages.sub_title_select_2fa)}
    title={intl.formatMessage(messages.title_select_2fa)}
  >
    <Column>
      <RadioContainer>
        <CenterRow>
          <Badge src={GoogleAuthenticator} />
          <Column>
            <Text color='black' weight={600}>
              {intl.formatMessage(messages.authenticator_app)}
            </Text>

            <Description color='dark200'>
              {intl.formatMessage(messages.description_authenticator)}
            </Description>
          </Column>
        </CenterRow>
      </RadioContainer>

      <ComingSoon color='dark200'>Additional two-factor methods are coming</ComingSoon>

      <CeruleanButton e2e='nextButton' type='submit'>
        {intl.formatMessage(messages.button_next)}
      </CeruleanButton>
    </Column>
  </Container>
)

export default injectIntl(Method)
